import React, { useState, useEffect } from "react";
import { Upload } from "lucide-react";
import "./ProductImage.css";
import BaseButton from "../Common/BaseButton";

const ProductImage = ({ initialHeroImage, initialProductImages, previewMode, onHeroImageChange, onProductImagesChange }) => {
  const [heroImage, setHeroImage] = useState(initialHeroImage );
  const [productImages, setProductImages] = useState(initialProductImages || []);

  useEffect(() => {
    setHeroImage(initialHeroImage);
  }, [initialHeroImage]);

  useEffect(() => {
    setProductImages(initialProductImages || []);
  }, [initialProductImages]);

  const handleImageUpload = (e, type) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        if (type === "hero") {
          setHeroImage(e.target.result);
          // Notify parent component of hero image change
          if (onHeroImageChange) {
            onHeroImageChange(e.target.result, file);
          }
        } else {
          const newProductImages = [...productImages, e.target.result];
          setProductImages(newProductImages);
          // Notify parent component of product images change
          if (onProductImagesChange) {
            onProductImagesChange(newProductImages, file);
          }
        }
      };
      reader.readAsDataURL(file);
    }
  };
  
  const handleRemoveImage = (index) => {
    const newProductImages = productImages.filter((_, i) => i !== index);
    setProductImages(newProductImages);
    // Notify parent component of product images change
    if (onProductImagesChange) {
      onProductImagesChange(newProductImages);
    }
  };
  
  return (
    <div className="product-image-container">
      <div className="row">
        <div className="col-12 col-md-6 mb-4">
          <div className="section">
            <div className="section-header">
              <h2>Product hero image</h2>
            </div>
            {!previewMode &&( <div className="button-group">
             
               <BaseButton
                className="outlineprimary"
                children="Regenerate Image"
                imageSrc="/regenerate-image.svg"
                handleClick={() => console.log("Regenerating hero image")}
              />
              <label className="btn btn-outline-danger">
                <Upload size={16} />
                Upload Image
                <input
                  type="file"
                  hidden
                  accept="image/*"
                  onChange={(e) => handleImageUpload(e, "hero")}
                />
              </label>
            </div>)}
           
            <div className="image-preview hero-image">
  <img src={heroImage} alt="Product hero" />
  <div className="imgButton-container">
    <button
      className="add-image-btn btn bgprimary"
      onClick={() => document.getElementById("productImageUpload").click()}
    >
      Add Another Image
    </button>
  </div>
</div>

          </div>
        </div>

        <div className="col-12 col-md-6">
          <div className="section">
            <div className="section-header">
              <h2>Product Images</h2>
            </div> {!previewMode && (  <div className="button-group">
              <BaseButton
                className="outlineprimary"
                children="Regenerate Image"
                imageSrc="/regenerate-image.svg"
                handleClick={() => console.log("Regenerating product images")}
              />
              <label className="btn btn-outline-danger">
                <Upload size={16} />
                Upload Image
                <input
                  type="file"
                  hidden
                  accept="image/*"
                  onChange={(e) => handleImageUpload(e, "product")}
                />
              </label>
            </div>)}
          
            <div className="product-images-grid">
              {productImages.length > 0  ? (
                <>
                  {(productImages.length > 0 && productImages ).map((image, index) => (
                    <div key={index} className="image-preview">
                      <img src={image} alt={`Product ${index + 1}`} className="product-image"/>
                      <button
                        className="remove-image-btn"
                        onClick={() => handleRemoveImage(index)}
                      >
                        ✖
                      </button>
                    </div>
                  ))}
              
                </>
              ) : (
                <div
                  className="main d-flex justify-content-center align-items-center"
                  onClick={() =>
                    document.getElementById("productImageUpload").click()
                  }
                >
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    <div className="add-image-btn d-flex justify-content-center align-items-center">
                      <Upload size={24} />
                    </div>
                    <button className="btn bgprimary mt-2">Add Image</button>
                  </div>
                </div>
              )}
              <input
                id="productImageUpload"
                type="file"
                hidden
                accept="image/*"
                onChange={(e) => handleImageUpload(e, "product")}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductImage;
